import { render, staticRenderFns } from "./OperationsDashboard.vue?vue&type=template&id=aab4692e&scoped=true&"
import script from "./OperationsDashboard.vue?vue&type=script&lang=js&"
export * from "./OperationsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./operations-dashboard.css?vue&type=style&index=0&id=aab4692e&scoped=true&lang=css&"
import style1 from "./OperationsDashboard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab4692e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VDialog,VIcon})
